/**
 * A utility function to conditionally join classNames together.
 *
 * @param {string[]} classes - Array of class names.
 * @returns {string} - The joined class names.
 */
export function cn(...classes) {
    return classes.filter(Boolean).join(' '); // Filters out any falsy values and joins the classes with a space
  }
  